import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=09990ceb&scoped=true&"
import script from "./ChatPopup.vue?vue&type=script&lang=ts&"
export * from "./ChatPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=09990ceb&prod&lang=scss&scoped=true&"
import style1 from "./ChatPopup.vue?vue&type=style&index=1&id=09990ceb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09990ceb",
  null
  
)

export default component.exports